module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"header":"Naujienos"},"en":{"header":"News"}}')
  delete Component.options._Ctor
}
